import { CookieConsentData, useCookieConsent } from '@cvent/cookieconsent';
import { CodeSnippet, CodeSnippetCategory } from '@graphql/gql/graphql';

type UseCodeSnippets = {
  codeSnippets: CodeSnippet[];
  showCookieBanner?: boolean;
  showNonEssentialCookieBanner?: boolean;
};

/**
 * Hook to filter code snippets based on cookie consent choices
 */
const useCodeSnippets = ({
  codeSnippets,
  showCookieBanner,
  showNonEssentialCookieBanner
}: UseCodeSnippets): CodeSnippet[] => {
  const choices = useCookieConsent();
  const cookieConsent: CookieConsentData = {
    Functionality: choices.canSetFunctionalityCookies,
    Performance: choices.canSetPerformanceCookies,
    Marketing: choices.canSetMarketingCookies
  };

  if (showCookieBanner === undefined || showNonEssentialCookieBanner === undefined) {
    return [];
  }

  if (!showCookieBanner || !showNonEssentialCookieBanner) {
    return codeSnippets;
  }

  const allCookiesEnabled = cookieConsent.Functionality && cookieConsent.Marketing && cookieConsent.Performance;
  if (allCookiesEnabled) {
    return codeSnippets;
  }

  return codeSnippets.filter(snippet => {
    switch (snippet.category) {
      case CodeSnippetCategory.Unknown:
        return !snippet.canDisableCodeSnippet;
      case CodeSnippetCategory.StrictlyNecessary:
        return true;
      case CodeSnippetCategory.Functionality:
      case CodeSnippetCategory.Performance:
      case CodeSnippetCategory.Marketing:
        return snippet.canDisableCodeSnippet ? cookieConsent[snippet.category] ?? false : true;
      default:
        return false;
    }
  });
};

export default useCodeSnippets;
